import React from "react";
import styles from "./index.module.scss";
import { Modal } from "antd";
import PrescriptionDisplayComponent from "../PrescriptionDisplayComponent/PrescriptionDisplayComponent";

function PrescriptionDisplayModal({ isOpen = true, onClose }) {
  return (
    <Modal
      className={styles.display_priscription_modal_container}
      footer={false}
      closeIcon={<></>}
      open={isOpen}
      onCancel={() => {
        onClose && onClose(false);
      }}
    >
      <PrescriptionDisplayComponent />
    </Modal>
  );
}

export default PrescriptionDisplayModal;
